export default __webpack_public_path__ + "static/media/prompt_vector2.5d7d4bc8.png";